import { Injector } from "@angular/core";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";
import { Art57Node } from "../Art57Node";
import { FieldDefinition } from "../../../../../sections/createSendProductReport/message/fieldDefinition";
import { DrugIndication } from "../../../Data/Art57Data/DrugIndication";
import { CodeName } from "../../../../service/lookup-service/code-name.model";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { SectionName } from "../../../SectionName";
import { ErrorControlUtil } from "../../../ErrorControlUtil";
import { environment } from "../../../../../../environments/environment";
import { Art57NodeUtils } from "../Art57NodeUtils";
import { TreeNodeAuthorisedProduct } from "./TreeNodeAuthorisedProduct";
import { TreeNode } from "primeng/api";
import { TreeNodeDevelopmentProduct } from "./TreeNodeDevelopmentProduct";

export class TreeNodeDrugIndication extends Art57Node {
  constructor(injector: Injector, parent: Art57Node) {

    let operationtype = undefined;
    if (parent &&
      parent.parent &&
      parent.parent.data &&
      parent.parent.data.model) {
      operationtype = parent.parent.data.model.operationtype;
    }

    super(
      injector,
      new DrugIndication(injector, new FieldDefinition(injector), operationtype),
      'Drug Indication'
    );
    this.parent = parent;
    this.labelNodeName = 'Drug Indication';
    this.ioc!.get(Art57Section).generateNumColumValue(this);

    this.ioc!.get(LookupGetService).retrieveFromCache("supportedmeddraversions").subscribe(data => {
      this.data.model.meddraversion = data[0].code;
    });

    this.refreshLabel();
  }

  private generateLabel(medVers: string, medLevel: string, medTerm: String): string {
    let label = '';

    if (medVers != '') {
      label = 'Ver. ' + medVers;
    }

    if (medLevel != '') {
      if (label == '') {
        label = medLevel;
      } else {
        label = label + ' - ' + medLevel;
      }
    }

    if (medTerm != '') {
      label = medTerm + ' - ' + label;
    }

    if (label == '') {
      label = this.labelTemplate;
    }

    return label;
  }
  override refreshLabel(lazy: boolean = true): void {
    let medVers = '';
    let medLevel = '';
    let medTerm = '';

    if (this.data && this.data.model &&
      this.data.model.meddraversion) {
      medVers = this.ioc!.get(LookupGetService).retrieveValueFromCache('supportedbacklogmeddraversions', this.data.model.meddraversion);
    }

    if (this.data && this.data.model &&
      this.data.model.meddralevel) {
      medLevel = this.ioc!.get(LookupGetService).retrieveValueFromCache('meddraLevel', this.data.model.meddralevel);
    }

    if (this.data && this.data.model &&
      this.data.model.meddracode &&
      this.data.model.meddracode.value) {
      if (this.data.model.meddracode.name) {
        medTerm = this.data.model.meddracode.name
      }
    }

    if (medVers && medLevel && !medTerm) {
      if (!lazy) {
        if (!medTerm && medVers && medLevel && this.data.model.meddracode) {
          this.ioc!.get(LookupGetService).getLookup(this.data.model.meddralevel, this.data.model.meddracode.value + "_v" + this.data.model.meddraversion)
            .then((result: CodeName) => {
              if (result && result.name && result.name != '') {
                this.data.model.meddracode.name = result.name;
                this.refreshLabel();
              }
            });
        }
      }
    }

    this.label = this.generateLabel(medVers, medLevel, medTerm);

  }

  override getListItem(): any[] {
    return [
      this.data.model && this.data.model.meddraversion
        ? this.ioc!.get(LookupGetService).retrieveValueFromCache('supportedbacklogmeddraversions', this.data.model.meddraversion)
        : 'Not selected',
      this.data.model && this.data.model.meddralevel
        ? this.data.model.meddralevel.toString().toUpperCase()
        : 'Not selected',
      this.data.model &&
        this.data.model.meddracode &&
        this.data.model.meddracode.name
        ? this.data.model.meddracode.name
        : 'Not selected',
    ];
  }

  override cloneNode(newParent: Art57Node): Art57Node {
    let clonedNode: TreeNodeDrugIndication = new TreeNodeDrugIndication(
      this.ioc!,
      newParent
    );


    clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
    if (this.ioc?.get(Art57Section).selectionSectionName == SectionName.createandsendproductreports) {

      let node: TreeNode | null = Art57NodeUtils.findFirstParentNodeOfType(clonedNode, TreeNodeAuthorisedProduct || TreeNodeDevelopmentProduct);
      const isInvalidateOrNullifyOperation =
        (node &&
          node.data &&
          node.data.model &&
          ([4, 6].includes(node.data.model.operationtype)));


      if (!isInvalidateOrNullifyOperation) {

        this.ioc.get(LookupGetService).retrieveFromCache("supportedmeddraversions").subscribe(data => {
          if (!data.find(d => d.code == clonedNode.data.model.meddraversion)) {
            clonedNode.data.model.meddraversion = data[0].code;
          }
        });
        
      }

    }

    clonedNode.refreshLabel();
    clonedNode.expanded = this.expanded && environment.userPreferences.autoexpandNodesOnCloning || environment.userPreferences.alwaysAutoexpandNodes

    return clonedNode;
  }

  override setMessage(jsonObject: any): void {

    this.ioc!.get(LookupGetService).retrieveFromCache("supportedmeddraversions").subscribe(data => {

      let node: TreeNode | null = Art57NodeUtils.findFirstParentNodeOfType(this, TreeNodeAuthorisedProduct || TreeNodeDevelopmentProduct);
      const isInvalidateOrNullifyOperation =
        (node &&
          node.data &&
          node.data.model &&
          ([4, 6].includes(node.data.model.operationtype)));

      if ((!isInvalidateOrNullifyOperation) && (!data.find(d => d.code == jsonObject.meddraversion))) {
        jsonObject.meddraversion = data[0].code;
      } else if (jsonObject.meddraversion) {
        jsonObject.meddraversion = Number(jsonObject.meddraversion);
      }

      super.setMessage(jsonObject);
      this.refreshLabel();
    });

  }

  override validateBusinessRules(): any[] {

    const sameReferenceByValuesBusinessErrors = ErrorControlUtil.sameReferenceByValues(this, ['meddracode'], 'Duplicated Meddra Term');
    let businessRulesErrors = [];

    if (sameReferenceByValuesBusinessErrors.length > 0) {
      businessRulesErrors.push(...sameReferenceByValuesBusinessErrors);
    }

    return businessRulesErrors;
  }

}